import React, { useEffect, useMemo, useState } from "react";
import { Votes } from "../../../pages";
import {
  BroadcastController,
  CompetitionController,
} from "../../../controllers";

const VotesContainer = () => {
  const [loading, setLoading] = useState(false);
  const [limit, setLimit] = useState(50);
  const [currentPage, setCurrentPage] = useState(0);
  const [searchQuery, setSearchQuery] = useState("");
  const [competition, setCompetition] = useState("");
  const [stage, setStage] = useState("");
  const [votesTableQuery, setVotesTableQuery] = useState({
    offset: 0,
    limit: limit,
  });

  const query = useMemo(() => {
    return `stage=${stage}&competition=${competition}`;
  }, [stage, competition]);

  useEffect(() => {
    const fetchPlan = async () => {
      await Promise.all([
        BroadcastController.getCompetitionParticipants(query),
        CompetitionController.getCompetitions(),
      ]);
    };

    fetchPlan();
  }, [query]);

  const onSubmit = async (values) => {
    setLoading(true);
    setVotesTableQuery({
      offset: currentPage + 1,
      limit: limit,
      ...(values.competition?.key && { competition: values.competition.key }),
      ...(values.stage && { stage: values.stage }),
      ...(values.participant?.key && { participant: values.participant.key }),
    });

    return setLoading(false);
  };

  const { isLoading, data, isFetching } =
    CompetitionController.useGetVotes(votesTableQuery);

  const onLimitChange = (limit) => {
    setLimit(limit);
    setCurrentPage(0);
  };

  return (
    <Votes
      onLimitChange={onLimitChange}
      data={data}
      currentPage={currentPage}
      setCurrentPage={setCurrentPage}
      limit={limit}
      isLoading={isLoading}
      isFetching={isFetching}
      setSearchQuery={setSearchQuery}
      setCompetition={setCompetition}
      setStage={setStage}
      onSubmit={onSubmit}
      loading={loading}
    />
  );
};

export default VotesContainer;
